import { useState } from 'react';
import { Search, HelpCircle, ChevronDown, Shield, Zap, Wallet } from 'lucide-react';
import './SupportPages.css';

const FAQPage = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [openIndex, setOpenIndex] = useState(null);
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Questions', icon: HelpCircle },
    { id: 'general', name: 'General', icon: Zap },
    { id: 'security', name: 'Security', icon: Shield },
    { id: 'wallet', name: 'Wallet', icon: Wallet },
  ];

  const faqs = [
    { category: 'general', q: 'What is Omini Bridge?', a: 'Omini Bridge is a non-custodial cryptocurrency exchange platform that allows you to swap between 1000+ cryptocurrencies instantly without registration.' },
    { category: 'general', q: 'How do I start exchanging?', a: 'Simply select your currencies, enter the amount, provide your receiving wallet address, and send your funds to the deposit address we provide.' },
    { category: 'general', q: 'What are the fees?', a: 'We charge a transparent 0.5% fee on all exchanges. Network fees are estimated and included in the rate shown.' },
    { category: 'security', q: 'Is Omini Bridge safe?', a: 'Yes! We are a non-custodial exchange, meaning we never hold your funds. All exchanges happen directly between wallets.' },
    { category: 'security', q: 'Do you store my data?', a: 'We only store transaction data necessary for processing. We never store your private keys or wallet passwords.' },
    { category: 'wallet', q: 'Which wallets are supported?', a: 'We support all major wallets including MetaMask, Trust Wallet, Ledger, Trezor, and any wallet that supports standard cryptocurrency addresses.' },
    { category: 'wallet', q: 'What if I enter the wrong address?', a: 'Always double-check addresses before confirming. Crypto transactions are irreversible. Contact support immediately if you make a mistake.' },
    { category: 'general', q: 'How long do exchanges take?', a: 'Most exchanges complete within 2-10 minutes depending on blockchain confirmation times. Some may take longer during network congestion.' },
    { category: 'security', q: 'Is KYC required?', a: 'No KYC is required for most exchanges. Some high-value transactions may require verification for compliance purposes.' },
    { category: 'general', q: 'What happens if something goes wrong?', a: 'Our 24/7 support team is always available to help. We have a 100% funds protection guarantee for any issues on our end.' },
  ];

  const filteredFaqs = faqs.filter(faq => {
    const matchesSearch = faq.q.toLowerCase().includes(searchTerm.toLowerCase()) || 
                         faq.a.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = activeCategory === 'all' || faq.category === activeCategory;
    return matchesSearch && matchesCategory;
  });

  return (
    <div className="support-page">
      <div className="support-bg">
        <div className="support-glow"></div>
      </div>

      <div className="support-container">
        {/* Hero */}
        <section className="support-hero">
          <div className="faq-badge">
            <HelpCircle size={20} />
            <span>FAQ</span>
          </div>
          <h1 className="support-title">
            Frequently Asked <span className="gradient-text">Questions</span>
          </h1>
          <div className="search-box-large">
            <Search size={24} />
            <input
              type="text"
              placeholder="Search questions..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </section>

        {/* Category Filters */}
        <section className="faq-categories">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className={`faq-cat-btn ${activeCategory === cat.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat.id)}
            >
              <cat.icon size={18} />
              {cat.name}
            </button>
          ))}
        </section>

        {/* FAQ List */}
        <section className="faqs-section full">
          <div className="faqs-list">
            {filteredFaqs.map((faq, index) => (
              <div 
                key={index} 
                className={`faq-item ${openIndex === index ? 'open' : ''}`}
              >
                <button className="faq-question" onClick={() => setOpenIndex(openIndex === index ? null : index)}>
                  <span>{faq.q}</span>
                  <ChevronDown size={20} className="faq-chevron" />
                </button>
                <div className="faq-answer">
                  <p>{faq.a}</p>
                </div>
              </div>
            ))}
          </div>
          {filteredFaqs.length === 0 && (
            <div className="no-results">
              <HelpCircle size={48} />
              <p>No questions found matching your search</p>
            </div>
          )}
        </section>

        {/* Still Need Help */}
        <section className="still-help">
          <h2>Still Have Questions?</h2>
          <p>Can&apos;t find what you&apos;re looking for? Contact our support team.</p>
          <button className="contact-support-btn">Contact Support</button>
        </section>
      </div>
    </div>
  );
};

export default FAQPage;
